<template>
  <div :class="['components-top-title components-top-title-' + classStyle]">
    <el-row v-if="title" class="fl">
      {{ title }}
    </el-row>
    <el-row v-else-if="titleList.length > 0" class="fl">
      <el-breadcrumb :separator-icon="ArrowRight">
        <el-breadcrumb-item v-for="(item, index) in titleList" :key="index">
          {{ item.title }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row class="fr">
      <slot />
    </el-row>
  </div>
</template>
<script setup lang="ts">
import { ArrowRight } from "@element-plus/icons-vue";
import { PropType, onMounted, ref } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  titleList: {
    type: Array as PropType<AnyType[]>,
    default() {
      return [];
    },
  },
  //标题展示样式
  display: {
    type: Number,
    default: 1,
  },
  isClick: {
    type: Boolean,
    default: false,
  },
});

const classStyle = ref(0);

onMounted(() => {
  classStyle.value = props.display;
});
</script>
<style scoped lang="scss">
.components-top-title {
  width: 100%;
  display: flex;
  %borderNone {
    border-bottom: none !important;
  }

  box-sizing: border-box;
  padding: 12px 24px;
  color: rgb(51, 51, 51);
  overflow: hidden;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #d8d8d8;

  .fl {
    font-size: 16px;
    line-height: 32px;
  }

  .popup-fl {
    background-color: #fff;
    margin-top: 10px;
    padding: 12px 24px;
    border-radius: 5px;
    box-sizing: border-box;
  }

  .fr {
    display: flex;
    flex-wrap: nowrap;
  }

  .popup-fr {
    padding: 12px 24px;
    box-sizing: border-box;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none !important;
  }

  .el-menu--horizontal {
    border-bottom: none !important;
  }

  .el-menu--horizontal > .el-menu-item {
    border-bottom: none !important;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
    color: rgb(51, 51, 51);
    padding: 0 20px 0 0;
  }

  .el-menu-item.is-active {
    @extend %borderNone;
  }

  .el-menu-item:not(.is-disabled):focus,
  .el-menu-item:not(.is-disabled):hover {
    background-color: #fff !important;
    color: $--color-primary;
    @extend %borderNone;
  }
}
.components-top-title-2 {
  color: #5893f5;
}
.components-top-title-3 {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  padding-bottom: 14px;
}
.components-top-title-4 {
  display: flex;
  border-radius: 5px;
}
.components-top-title-5 {
  color: #5893f5;
  margin-bottom: 15px;
  padding: 0 18px;
  > .fl {
    line-height: 41px;
  }
}
</style>
